'use strict';

angular.module('lingApp')
  .factory('RipDialog', function($q, RipDialogStack, RipStrings, i18n, RipDynamicDirective) {

    function openDialog(config) {
      config = angular.extend({backdrop: true, frame: true, dismissOnEsc: true }, config);
      config.resolve = config.resolve || {};

      var dialog = createDialog(config);

      RipDialogStack.push(dialog, config);

      return dialog;
    }

    function createDialog(config) {
      var callbacks = { handlers: [],
                        closeVal: undefined,
                        dismissVal: undefined
                      };

      return {
        result: function(closeHandler, dismissHandler) {
          if (!closeHandler) closeHandler = angular.identity;
          if (!dismissHandler) dismissHandler = angular.identity;

          if (angular.isDefined(callbacks.closeVal)) {
            return $q.when(closeHandler(callbacks.closeVal));

          } else if (angular.isDefined(callbacks.dismissVal)) {
            dismissHandler(callbacks.dismissVal);
            return $q.defer().promise;

          } else {
            var defer = $q.defer();
            callbacks.handlers.push({ defer: defer,
                                      closeHandler: closeHandler,
                                      dismissHandler: dismissHandler });
            return defer.promise;
          }
        },

        close: function(result) {
          callbacks.closeVal = result;

          var dialog = this;
          var closeDefer = $q.defer();
          var detectedError;

          angular.forEach(callbacks.handlers, function(handler, index) {
            var isLast = index === (callbacks.handlers.length - 1);

            $q
              .when(handler.closeHandler(result))
              .then(function(success) {
                handler.defer.resolve(success);
                if (!detectedError && isLast) {
                  closeDefer.resolve(success);
                }
              }, function(error) {
                handler.defer.reject(error);
                if (!detectedError) {
                  closeDefer.reject(error);
                  detectedError = true;
                }

              }, function(message) {
                handler.defer.notify(message);
              });
          });

          return closeDefer.promise.then(function(data) {
            dialog.dismiss('close');
          });
        },

        dismiss: function(reason) {
          callbacks.dismissVal = reason;

          angular.forEach(callbacks.handlers, function(handler) {
            handler.dismissHandler(reason);
          });

          RipDialogStack.pop(this);
        }
      };
    }

    return {
      open: function(config) {
        var frame = angular.element('<div rip-dialog></div>');
        frame.attr('window-style-name', config.windowStyleName);
        frame.attr('window-title', config.title);
        config.frame = frame;

        return openDialog(config);
      },

      popup: function(config) {
        if (!angular.isDefined(config.frame)) {
          config.frame = !!config.position;
        }

        if (!config.windowStyleName && config.frame) {
          config.windowStyleName = 'rip-dialog-popup-medium';
        }

        var frame = (config.frame
                     ? angular.element('<div rip-dialog-popup></div>')
                     : angular.element('<div rip-dialog-popup frame="true"></div>'));

        if (config.windowStyleName) {
          frame.addClass(config.windowStyleName);
        }

        var bindings = angular.isFunction(config.bindings) ? config.bindings() : config.bindings;

        if (config.directive) {
          config.template = RipDynamicDirective.compose(config.directive, bindings);
        }

        return openDialog({ frame: frame,
                            backdrop: !!config.backdrop,
                            controller: 'RipDialogPopupController',
                            template: config.template,
                            templateUrl: config.templateUrl,
                            resolve: { popup: () => {
                              return { position: config.position,
                                       title: config.title,
                                       modal: config.modal
                                     };
                            },
                                       bindings: function() { return bindings || {}; }
                                     }
                          });
      },

      editor: function(config) {
        var bindings = angular.isFunction(config.bindings) ? config.bindings() : config.bindings;

        var params = (_.chain(bindings)
                      .keys()
                      .push('onSubmit')
                      .map(function(key) { return RipStrings.camelCaseToSnakeCase(key) + '="' + key + '"'; })
                      .join(' ')
                      .value());

        var buttons = config.buttons || { ok: i18n('OK'), cancel: i18n('Cancel') };

        var controls = '';
        if (config.controls && config.controls.length) {
          controls = ('<div class="rip-dialog-footer-controls">'
                      + '<a href="javascript:void(0)" ng-click="control.onClick()" ng-repeat="control in controls">{{control.label}}</a>'
                      + '</div>');
          bindings.controls = config.controls;
        }

        var template = RipStrings.format('<{0} {1}>'
                                         + '<div class="rip-dialog-footer">'
                                         + '{2}'
                                         + '<div class="rip-dialog-footer-buttons">'
                                         +  '<button rip-form-button type="submit">{3}</button>'
                                         +  '<button rip-form-button type="button" ng-click="cancel()">{4}</button>'
                                         + '</div>'
                                         + '</div>'
                                         + '</{0}>',
                                         RipStrings.camelCaseToSnakeCase(config.directive),
                                         params,
                                         controls,
                                         buttons.ok,
                                         buttons.cancel);

        return this.open({ title: config.title,
                           template: template,
                           windowStyleName: config.windowStyleName,
                           controller: 'RipDialogEditorController',
                           resolve: { bindings : function() { return bindings; },
                                      dismissWhenUnmodified : function() {
                                        return (angular.isDefined(config.dismissWhenUnmodified)
                                                ? config.dismissWhenUnmodified
                                                : true);
                                      }}
                         });
      },

      info: function(message) {
         return this.message({ title: i18n('Info'),
                               template: require('views/rip-dialog-info.html'),
                               bindings: { message: message }
                            });
      },

      confirm: function(message) {
        return this.message({ title: i18n('Confirm'),
                              template: require('views/rip-dialog-confirm.html'),
                              windowStyleName: 'rip-dialog-confirm',
                              bindings: { message: message } });
      },

      warn: function(message) {
        return this.message({ title: i18n('Warning'),
                              template: require('views/rip-dialog-warn.html'),
                              bindings: { message: message }
                            });
      },

      wait: function(message) {
        return this.message({ title: i18n('Waiting'),
                              template: require('views/rip-dialog-wait.html'),
                              dismissOnEsc: false,
                              bindings: { message: message }
                            });
      },

      message: function(config) {
        return this.open({ title: config.title,
                           templateUrl: config.templateUrl,
                           template: config.template,
                           dismissOnEsc: !angular.isDefined(config.dismissOnEsc) || config.dismissOnEsc,
                           controller: 'RipDialogMessageController',
                           windowStyleName: config.windowStyleName || 'rip-dialog-message',
                           resolve: { bindings: function() {
                             return (angular.isFunction(config.bindings)
                                     ? config.bindings()
                                     : config.bindings);
                           }}
                         });
      }
    };
  })

  .factory('RipDialogStack', function($q, $injector, $document, $compile, $http, $templateCache, $rootScope, $controller) {

    var stack = (function() {
      var stack = [];

      return {
        push: function(dialog, state) {
          stack.push({ dialog: dialog, state: state });
        },

        get: function(dialog) {
          return _.find(stack, function(item) {
            return item.dialog === dialog;
          });
        },

        top: function() {
          return stack[stack.length - 1];
        },

        forEach: function(fn) {
          angular.forEach(stack, fn);
        },

        find: function(fn) {
          return _.find(stack, fn);
        },

        remove: function(dialog) {
          for (var i = 0; i < stack.length; ++i) {
            if (stack[i].dialog === dialog) {
              return stack.splice(i, 1)[0];
            }
          }

          return null;
        },

        pop: function() {
          return stack.splice(stack.length - 1, 1)[0];
        },

        isEmpty: function() {
          return 0 === stack.length;
        },

        length: function() {
          return stack.length;
        }
      };
    })();

    function getTemplatePromise(config) {
      return (config.template
              ? $q.when(config.template)
              : $http.get(config.templateUrl, { cache: $templateCache }).then(function(result) { return result.data; }));
    }

    function getResolvePromises(config) {
      var promises = [];
      angular.forEach(config.resolve, function(value) {
        if (angular.isFunction(value) || angular.isArray(value)) {
          promises.push($q.when($injector.invoke(value)));
        }
      });

      return promises;
    }

    function pushDialog(dialog, config) {
      $q
        .all([getTemplatePromise(config)].concat(getResolvePromises(config)))
        .then(function onSuccess(templateAndResolve) {
          var dialogScope = (config.scope || $rootScope).$new();
          dialogScope.close = _.bind(dialog.close, dialog);
          dialogScope.dismiss = _.bind(dialog.dismiss, dialog);

          if (config.controller) {
            var locals = { scope: dialogScope, dialog: dialog };
            var resolveIndex = 1;
            angular.forEach(config.resolve, function(value, key) {
              locals[key] = templateAndResolve[resolveIndex++];
            });
            $controller(config.controller, locals);
          }

          pushDialogWithState(dialog, { scope: dialogScope,
                                        content: templateAndResolve[0],
                                        backdrop: config.backdrop,
                                        dismissOnEsc: config.dismissOnEsc,
                                        frame: config.frame });
        }, function(error) {
          dialog.dismiss(error);
        });
    }

    function dismissDialogOnEsc(evt) {
      if (27 === evt.which) {
        var top = stack.top();
        if (top) {
          $rootScope.$apply(function() {
            top.dialog.dismiss();
          });
        }
      }
    }

    function pushDialogWithState(dialog, state) {
      var body = $document.find('body').eq(0);

      if (state.backdrop) {
        if (!state.backdropElement) {
          state.backdropElement = angular.element('<div class="rip-dialog-backdrop"></div>');
        }

        state.backdropElement[0].style.zIndex = stack.length();

        body.append(state.backdropElement);
      }

      if (stack.isEmpty() && state.dismissOnEsc) {
        $document.bind('keydown', dismissDialogOnEsc);
      }

      var frame = state.frame;
      frame.html(state.content);
      frame[0].style.zIndex = stack.length();
      body.append(frame);

      state.frameElement = $compile(frame)(state.scope);

      stack.push(dialog, state);
    }

    function popDialog(dialog) {
      var item = stack.get(dialog);
      if (!item) return;

      stack.remove(dialog);

      var state = item.state;
      state.frameElement.remove();
      state.scope.$destroy();

      if (state.backdropElement) {
        state.backdropElement.remove();
      }

      if (stack.isEmpty()) {
        $document.unbind('keydown', dismissDialogOnEsc);
      }
    }

    function getTopDialog() {
      return stack.top().dialog;
    }

    return {
      push: pushDialog,
      pop: popDialog,
      top: getTopDialog
    };
  })

  .directive('ripDialog', function($timeout) {
    return {
      template: require('views/rip-dialog-window.html'),
      restrict: 'A',
      replace: true,
      transclude: true,
      link: function postLink(scope, element, attrs) {
        scope.windowStyleName = attrs.windowStyleName || '';
        scope.windowTitle = attrs.windowTitle || '';
        $timeout(function() { element[0].focus(); });
      }
    };
  })

  .directive('ripDialogPosition', function($window, $timeout, $document, RipDom) {
    return {
      restrict: 'A',
      require: '?ripBoxResizer',
      link: function(scope, element, attrs, resizeCtrl) {
        var centerCounter = 0;
        var offset = { width: element[0].offsetWidth,
                       height: element[0].offsetHeight };
        var uncenter = scope.$watch(monitoringCenter, asyncCenter);
        var position = { x: 0, y: 0 };

        var targetElement = RipDom.getChildAtIndex(element, 0);

        targetElement
          .bind('mousedown', beginPosition)
          .bind('touchstart', beginPosition);

        if (resizeCtrl) {
          scope.$on('$destroy', resizeCtrl.addObserver(adjustPosition));
        }

        function adjustPosition(event) {
          stopCentering();

          element[0].style.top = (element[0].offsetTop + event.deltaTop) + 'px';
          element[0].style.left = (element[0].offsetLeft + event.deltaLeft) + 'px';
        }

        function stopCentering() {
          if (uncenter) {
            uncenter();
            uncenter = null;

            element[0].style.top = element[0].offsetTop + 'px';
            element[0].style.left = element[0].offsetLeft + 'px';
            element[0].style.marginLeft = '0px';
            element[0].style.marginTop = '0px';
          }
        }

        function monitoringCenter() {
          var width = element[0].offsetWidth;
          var height = element[0].offsetHeight;

          if (5 < Math.abs(width - offset.width)
              || 5 < Math.abs(height - offset.height)) {
            ++centerCounter;
          }

          return centerCounter;
        }

        function asyncCenter() {
          center();
          $timeout(center);
        }

        function center() {
          offset.width = element[0].offsetWidth;
          offset.height = element[0].offsetHeight;

          var top = Math.max(5, offset.height >> 1);
          var left = Math.max(5, offset.width >> 1);

          element[0].style.top = '50%';
          element[0].style.left = '50%';
          element[0].style.marginLeft = -left + 'px';
          element[0].style.marginTop = -top + 'px';
        }

        function beginPosition(event) {
          var rec = element[0].getBoundingClientRect();

          if (event.touches && 0 < event.touches.length) {
            event = event.touches[0];
          }

          position.x = event.clientX - rec.left;
          position.y = event.clientY - rec.top;
          position.width = rec.width;
          position.height = rec.height;

          $document.bind('mousemove', continuePosition);
          $document.bind('mouseup', endPosition);

          $document.bind('touchmove', continuePosition);
          $document.bind('touchend', endPosition);
          $document.bind('touchleave', endPosition);
          $document.bind('touchcancel', endPosition);
        }

        function continuePosition(event) {
          stopCentering();

          event.preventDefault();
          event.stopPropagation();

          if (event.touches && 0 < event.touches.length) {
            event = event.touches[0];
          }

          var top = event.clientY - position.y;
          var left = event.clientX - position.x;

          top = Math.max(5, Math.min(top, $window.innerHeight - 40));
          left = Math.max(-position.width + 40, Math.min(left, $window.innerWidth - 40));

          element[0].style.top = top + 'px';
          element[0].style.left = left + 'px';
        }

        function endPosition(event) {
          $document.unbind('mousemove', continuePosition);
          $document.unbind('mouseup', endPosition);

          $document.unbind('touchmove', continuePosition);
          $document.unbind('touchend', endPosition);
          $document.unbind('touchleave', endPosition);
          $document.unbind('touchcancel', endPosition);
        }
      }
    };
  })

  .directive('ripDialogPopup', function($document, $timeout, RipDialogStack) {
    return {
      templateUrl: function(tElements, tAttrs) {
        return ('true' === tAttrs.frame
                ? require('views/rip-dialog-popup-window.html')
                : require('views/rip-dialog-popup.html'));
      },
      restrict: 'A',
      replace: true,
      transclude: true,
      link: function(scope, element, attrs) {
        var dialog = RipDialogStack.top();

        if (scope.popup.position) {
          element.css({ top: scope.popup.position.top + 'px',
                        left: scope.popup.position.left + 'px'
                      });
        }

        if (!scope.popup.modal) {
          $timeout(function() {
            $document.bind('click', dismiss);
          });

          scope.$on('$destroy', function() {
            $document.unbind('click', dismiss);
          });
        }

        function dismiss(event) {
          if (!element[0].contains(event.target)) {
            dialog.dismiss();
          }
        }
      }
    };
  })

  .controller('RipDialogMessageController', function(scope, dialog, bindings) {
    angular.extend(scope, bindings);

    scope.dismiss = _.bind(dialog.dismiss, dialog);

    scope.ok = function() {
      dialog.close(true);
    };
    scope.cancel = function() {
      dialog.close(false);
    };
  })

  .controller('RipDialogPopupController', function(scope, dialog, popup, bindings) {
    scope.popup = popup;
    angular.extend(scope, bindings);
  })

  .controller('RipDialogEditorController', function($q, scope, dialog, bindings, dismissWhenUnmodified) {
    angular.extend(scope, bindings);

    scope.onSubmit = function(newRecord, originalRecord) {
      if (dismissWhenUnmodified && angular.equals(newRecord, originalRecord)) {
        return dialog.dismiss('unmodified');

      } else {
        return dialog.close(newRecord);
      }
    };

    scope.cancel = function() {
      dialog.dismiss('cancel');
    };
  })
;
